export const gridViewTypes = Object.freeze({
	None: 0,
	Grids: 1,
	InventoryForm: 2,
	InventoryFormFilters: 3,
	DataImportTemplate: 4,
	Report: 5,
});
